import _get from 'lodash/get';

import { getCurrencyByCountry } from '../utils/balance';


export const getWebmasterBalanceInCredits = state => _get(state, 'webmaster.balance');
export const getWebmasterBalanceSummaryInCredits = state => _get(state, 'webmaster.balanceSummary');

export const getWebmasterProfile = state => _get(state, 'webmaster.profile');
export const getWebmasterProfileNick = state => _get(getWebmasterProfile(state), 'nick');
export const getWebmasterProfileCountry = state => _get(getWebmasterProfile(state), 'country');
export const getWebmasterProfileFirstname = state => _get(getWebmasterProfile(state), 'firstname');
export const getWebmasterProfileLastname = state => _get(getWebmasterProfile(state), 'lastname');
export const getWebmasterWebmasterType = state => _get(getWebmasterProfile(state), 'webmasterType');
export const getWebmasterMinSumToPayout = state => _get(getWebmasterProfile(state), 'minSumToPayout');
export const getWebmasterEmail = state => _get(getWebmasterProfile(state), 'email');
export const getIsCheckUsed = state => (
  _get(getWebmasterProfile(state), 'contactsRequiredDependencies.isCheckUsed')
);
export const getIsW9FormApproved = state => (
  _get(getWebmasterProfile(state), 'contactsRequiredDependencies.isW9FormApproved')
);

export const getWebmasterCurrency = state => (
  getCurrencyByCountry(getWebmasterProfileCountry(state))
);

export const getWebmasterMinSumToPayoutInCurrency = state => {
  const currency = getWebmasterCurrency(state);
  const amount = getWebmasterMinSumToPayout(state);

  let result = null;
  if (amount && currency) {
    result = {
      currency,
      amount,
    };
  }

  return result;
};


export const getLoadBalanceError = state => _get(state, 'webmaster.errors.loadBalanceError');
export const getLoadBalanceSummaryError = state => _get(state, 'webmaster.errors.loadBalanceSummaryError');
export const getLoadWebmasterProfileError = state => _get(state, 'webmaster.errors.loadWebmasterProfileError');
export const getEditWebmasterProfileError = state => _get(state, 'webmaster.errors.editWebmasterProfileError');
